(() => {
  'use strict';
  const ENDPOINT = 'https://account.slimava.com/api/portal/resolve';
  const CURRENT = 'https://account.slimava.com/account/login';
  const LEGACY = 'https://slimava.com/a/loop_subscriptions/customer';
  const TIMEOUT = 15000;

  function initialize(root) {
    if (root.dataset.slSubscriptionReady === 'true') return;
    root.dataset.slSubscriptionReady = 'true';
    const form = root.querySelector('[data-sl-subscription-form]');
    const emailInput = root.querySelector('[data-sl-subscription-email]');
    const submit = root.querySelector('[data-sl-subscription-submit]');
    const status = root.querySelector('[data-sl-subscription-status]');
    const options = root.querySelector('[data-sl-subscription-options]');
    const current = root.querySelector('[data-sl-subscription-current]');
    if (!form || !emailInput || !submit || !status || !options || !current) return;
    let generation = 0;
    let controller;
    let pending = false;
    const currentUrl = email => CURRENT + '#email=' + encodeURIComponent(email);
    function busy(value) {
      pending = value;
      submit.disabled = value;
      submit.textContent = value ? 'Finding your portal…' : 'Continue';
      form.setAttribute('aria-busy', String(value));
    }
    function clear() {
      status.textContent = '';
      status.removeAttribute('data-error');
      emailInput.removeAttribute('aria-invalid');
      options.hidden = true;
      current.href = CURRENT;
    }
    function show(message, email, error = false) {
      status.textContent = message;
      status.dataset.error = String(error);
      options.hidden = false;
      current.href = currentUrl(email);
      status.focus({ preventScroll: true });
    }
    emailInput.addEventListener('input', () => {
      generation++;
      if (controller) controller.abort();
      controller = undefined;
      busy(false);
      clear();
    });
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (pending) return;
      const email = emailInput.value.trim().toLowerCase();
      emailInput.value = email;
      if (!emailInput.reportValidity()) return;
      clear();
      const sequence = ++generation;
      const request = new AbortController();
      controller = request;
      busy(true);
      const timer = window.setTimeout(() => request.abort(), TIMEOUT);
      try {
        const response = await fetch(ENDPOINT, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ email }),
          credentials: 'omit',
          cache: 'no-store',
          referrerPolicy: 'no-referrer',
          signal: request.signal,
        });
        if (sequence !== generation) return;
        if (response.status === 400) {
          status.textContent = 'Please check your email address and try again.';
          status.dataset.error = 'true';
          emailInput.setAttribute('aria-invalid', 'true');
          emailInput.focus();
          return;
        }
        if (response.status === 429) {
          show('Please wait a moment and try again, or open your portal below.', email);
          return;
        }
        if (!response.ok) throw new Error('LOOKUP_UNAVAILABLE');
        const result = await response.json();
        if (sequence !== generation) return;
        if (!result || result.ok !== true) throw new Error('INVALID_RESPONSE');
        if (result.result === 'portal' && ['current', 'legacy'].includes(result.portal)) {
          status.textContent = 'Opening your portal…';
          window.location.assign(result.portal === 'current' ? currentUrl(email) : LEGACY);
        } else if (result.result === 'choose') {
          show('Your email is linked to both portals. Choose the subscription you want to manage.', email);
        } else if (result.result === 'unresolved') {
          show('We couldn’t find a single matching portal. Check your email address, or try a portal below.', email);
        } else throw new Error('INVALID_RESPONSE');
      } catch {
        if (sequence === generation) show('We couldn’t check your subscription right now. Try again, or open your portal below.', email);
      } finally {
        window.clearTimeout(timer);
        if (sequence === generation) { controller = undefined; busy(false); }
      }
    });
  }
  function start(scope) {
    if (scope.matches && scope.matches('[data-sl-subscription-entry]')) initialize(scope);
    scope.querySelectorAll('[data-sl-subscription-entry]').forEach(initialize);
  }
  start(document);
  document.addEventListener('shopify:section:load', event => start(event.target));
})();
